
import Table from '@/components/Table.vue';
import TableHeaderButtons from '@/components/TableHeaderButtons.vue'
import SearchPanel from '@/components/SearchPanel.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import { debounce } from 'lodash';
import { buildSearchFilters, buildJsonServerQuery, clearSearchFilters } from '@/utils/app-util';
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { baseModule } from '@/store/modules/bases';
import { appModule } from '@/store/modules/app';
import { flotaModule } from '@/store/modules/flotas';
import { userModule } from '@/store/modules/user';

@Component({
  components: {
    Table,
    TableHeaderButtons,
    SearchPanel,
    ConfirmDialog
  }
})
export default class BaseList extends Vue {
  public dialog = false;
  public dialogTitle = '';
  public dialogText = '';
  public showSearchPanel = false;
  public right = true;
  public search = '';
  public headers = [
    { text: 'Nombre', value: 'nombre' },
    { text: 'Vehículos', value: 'n_vehiculos' },
    { text: '', value: 'actions', sortable: false }
  ];
  private searchFilter = {
    contain: {
      reference: '',
      customer: ''
    },
    greaterThanOrEqual:{
      amount: 0
    },
    lessThanOrEqual:{
      amount: 0
    },
  };
  // private orderId = '';
  private query = '';
  private color = '';
  private quickSearchFilter = '';
  private itemId = -1;

  edit(item) {
    this.$router.push(`/base/${item.id}`);
  }
  view(item) {
    this.$router.push(`/bases/${item.id}/vehiculos`);
  }
  add() {
    this.$router.push('/NewBase');
  }
  remove(item) {
    this.itemId = item.id;
    this.dialog = true;
  }
  onConfirm() {
    baseModule.deleteBase(this.itemId).then(data=>{
      this.getBaseByIdFlota();
      appModule.sendSuccessNotice("Base borrada correctamente.");
    });
    this.dialog = false;
  }
  onCancel() {
    this.itemId = -1;
    this.dialog = false;
  }

  getBaseByIdFlota() {
    baseModule.getBaseByIdFlota(this.$route.params.id);
  }


  clearSearchFilters() {
    this.showSearchPanel = !this.showSearchPanel;
    clearSearchFilters(this.searchFilter);
    baseModule.getAllBases();
  }

  reloadData() {
    this.query = '';
    this.getBaseByIdFlota();
  }

   updateSearchPanel(){
    this.rightDrawer=!this.rightDrawer;
  }

  cancelSearch() {
    this.showSearchPanel = false;
  }

  closeSnackbar() {
    appModule.closeNotice();
  }

  get user() {
    return userModule.user;
  }

  get nombreFlota() {
    return flotaModule.flota.nombre;
  }

  get items() {
    return baseModule.items;
  }
  get pagination() {
    return baseModule.pagination;
  }
  get loading() {
    return appModule.loading;
  }
  get mode() {
    return appModule.mode;
  }
  get snackbar() {
    return appModule.snackbar;
  }
  get notice() {
    return appModule.notice;
  }

  get rightDrawer() {
    return this.showSearchPanel;
  }

  set rightDrawer(_showSearchPanel: boolean) {
    this.showSearchPanel = _showSearchPanel;
  }

  created() {
    if (this.$route.params.id) {
      this.getBaseByIdFlota();
      flotaModule.getFlotaById(this.$route.params.id);
    } else{
      baseModule.getAllBases();
    }
  }
  mounted() {
    this.dialogTitle = this.$t("message.Borrar base");
    this.dialogText = this.$t("message.¿Quieres borrar esta base?");
    this.headers = [
      { text: this.$t("message.Nombre"), value: 'nombre' },
      { text: this.$t("message.Vehículos"), value: 'n_vehiculos' },
      { text: '', value: 'actions', sortable: false }
    ];
    // this.$nextTick(() => {
    //   console.log(this.headers);
    // });
  }
}
